export default "__VITE_ASSET__B2I8jA4E__"